import mapResponseToInvoiceSettings from './mappers/mapResponseToInvoiceSettings'
import { IInvoiceSettings } from './index'

export default function updateInvoiceSettings(api: GlobalFetch) {
  return async function(settings: IInvoiceSettings) {
    const requestBody = {
      active_second_tax: settings.activeSecondTax ? '1' : '0',
      show_dates_on_invoice: settings.show_dates_on_invoice ? '1' : '0',
      active_tax: settings.activeTax ? '1' : '0',
      default_second_tax_name: String(settings.secondTaxName),
      default_second_tax_rate: String(settings.secondTaxRate),
      default_tax_name: String(settings.taxName),
      default_tax_rate: String(settings.taxRate),
      id: String(settings.id),
      id_object: String(settings.idObject),
    }

    const buildUrl = `/api/v2/invoice/settings/`

    const response = await api.fetch(buildUrl, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    const responseBody: IData = await response.json()

    return mapResponseToInvoiceSettings(responseBody)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

interface IItemData {
  id: string
  id_object: string
  active_tax: string
  active_second_tax: string
  default_tax_name: string
  default_second_tax_name: string
  default_tax_rate: string
  default_second_tax_rate: string
  created_at: string
  updated_at: string
  show_dates_on_invoice: string
}
